import * as React from "react"
import moneyFlowHelper from "@digits-shared/helpers/moneyFlowHelper"
import { CurrencyStyle } from "@digits-shared/helpers/numberHelper"
import { type TimeseriesValue } from "src/frontend/components/Shared/Layout/Components/Charts/toTimeseries"
import {
  useTimeseriesToDisplay,
  useTimeSeriesTotal,
} from "src/frontend/components/Shared/Layout/Components/Headers/headersHelpers"
import { TileCardHeading } from "src/frontend/components/Shared/Layout/Components/Tiles/TileCard"
import { TileDelta } from "src/frontend/components/Shared/Layout/Components/Tiles/TileDelta"

interface HeadingProps {
  className?: string
  timeseries?: TimeseriesValue[]
  selectedIndex?: number | number[]
  defaultValueNode?: React.ReactNode
}

export const TimeseriesCardHeading: React.FC<HeadingProps> = ({
  className,
  timeseries,
  selectedIndex,
  defaultValueNode,
}) => {
  const timeseriesToDisplay = useTimeseriesToDisplay(timeseries, selectedIndex)
  const moneyFlow = useTimeSeriesTotal(timeseriesToDisplay)

  const noActivity = React.useMemo(
    () => timeseries?.every((value) => value.moneyFlow.value.amount === 0),
    [timeseries]
  )
  const showDefaultValue = selectedIndex === undefined && defaultValueNode !== undefined
  return (
    <TileCardHeading className={className} noActivity={noActivity}>
      {showDefaultValue
        ? defaultValueNode
        : timeseriesToDisplay && (
            <>
              {moneyFlowHelper.currency(moneyFlow, {
                style: CurrencyStyle.Summary,
              })}
              <TileDelta timeseriesToDisplay={timeseriesToDisplay} />
            </>
          )}
    </TileCardHeading>
  )
}
